<template>
  <PortalWidget :widget="widgetTitle">
    <p />

    <PublisherRegistrationSettingsForm
      v-if="!isLoadingSettings"
      :setting="prpSettings"
    />

    <div
      v-if="isLoadingSettings"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'PRP_SETTINGS_LOADING'" />
    </div> 
  </PortalWidget>
</template>

<script>

import messages from '../../locales';
import PortalWidget from '@/core/components/PortalWidget.vue';
import Loader from '@/core/components/Loader';
import PublisherRegistrationSettingsForm from './PublisherRegistrationSettingsForm';
import { mapActions, mapState } from 'vuex';
import { STATUS_PENDING, getStatus } from '@/store/helpers';
import { LOAD_PRP_SETTINGS } from '../../store/actionTypes';

export default {
  components: { 
    PortalWidget,
    Loader,
    PublisherRegistrationSettingsForm
  },

  data() {
    return {
      widgetTitle: { title:this.$i18n.t('PRP_SETTINGS_PAGE_TITLE'), iconClass: 'typcn typcn-group'}
    };
  },

  computed: {
    ...mapState('openRegistrationStore', {
      loadSettingsStatus: (state) => getStatus(state, LOAD_PRP_SETTINGS),
    }),
    ...mapState('openRegistrationStore', [
      'prpSettings',
    ]),
    isLoadingSettings() {
      return this.loadSettingsStatus.status == STATUS_PENDING;
    },
  },

  created() {
    this.loadPRPSettings();
  },

  methods: {
    ...mapActions('openRegistrationStore', [
      LOAD_PRP_SETTINGS,
    ]),
  },

  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>